import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  paper: {
    paddingTop: 12,
    color: (props) =>
      props.eventStyles.sidebar_font_color ? props.eventStyles.sidebar_font_color : '#4A4A4A',
    backgroundColor: (props) =>
      props.eventStyles.sidebar_color ? props.eventStyles.sidebar_color : '#3BBBE6',
    borderRadius: 5,
    boxShadow: '0 0 10px 0 rgba(155, 155, 155, 0.3)',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
    },
  },
  title: {
    display: 'flex',
    padding: '0 16px',
    paddingBottom: 4,
    fontSize: '1.125rem',
    fontWeight: 600,
    lineHeight: '1.5rem',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  icon: {
    width: '30px',
    height: '30px',
    position: 'relative',
    top: '-1px',
    marginRight: '8px',
  },
  rootListItemText: {
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: '1rem',
  },
  vdoSection: {
    display: 'flex',
  },
  vdoPlayer: {
    flex: '0 0 auto',
  },
  vdoDetails: {
    flex: '1 1 auto',
    paddingLeft: 8,
  },
}))

export default useStyles
